// Export your reducers from here
import {combineReducers} from 'redux';
import b2b from './b2b';
import misc from './misc';
const reducers = combineReducers({
  misc,
  b2b
});

export default reducers;


// WEBPACK FOOTER //
// ./src/app/redux/reducers/index.js